module.exports = __webpack_public_path__ + "img/DSC_4492.3a60cc9f.jpg";